/**
 * @template T
 * @param {T | null | undefined} value The value to check
 * @param {string} [message] The message to display if the assertion fails
 * @returns {asserts value is T} `undefined` if `value` is neither `null` nor `undefined`, otherwise throws an error.
 */
function invariant(value, message) {
  if (value === false || value === null || value === undefined) {
    throw new Error(message);
  }
}

export { invariant as default };
